import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// d.ts

// Material-UI Core Components
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

// Custom Components
import { Button, CircularProgress, Stack } from '@mui/material';
import PublicPage from '@/ui/PublicPage/PublicPage';
import Loader from '@/ui/Loader/Loader';

import { authService } from '@/services/authService';
// import { DCRecord } from "@/@types/lib/dataController";
import { ResetPasswordToken } from '@/@types/views/Auth/passwordreset';

function RegistrationConfirmPage() {
  const [token, setToken] = useState<ResetPasswordToken>({
    ok: null,
    email: null,
  });
  const [tokenStatus, setTokenStatus] = useState<string>('');
  const [resentActivation, setResentActivation] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (paramToken) {
      setIsLoading(true);
      authService
        .confirmRegisterToken(paramToken)
        .then((response) => {
          setToken({
            ok: true,
            email: response.email,
          });
          setTokenStatus('success');
        })
        .catch((error) => {
          setTokenStatus(error.error.errorMsg);
          setToken({
            ok: false,
          });
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, []);

  const getQueryToken = () => {
    const { search } = location;
    const params = new URLSearchParams(search);
    const queryToken = params.get('token');
    return queryToken;
  };

  const paramToken = getQueryToken();

  // let defaultValues: DCRecord = {};
  // if (token.ok && token.email) {
  //   defaultValues = {
  //     email: token.email,
  //     passwordreset_token: paramToken,
  //   };
  // }

  const resendActivation = () => {
    setResentActivation(true);
    authService
      .resendRegisterToken(paramToken as string, '', '')
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const iconColor = tokenStatus === 'token_expired' || "token_used" ? "warning" : "error";
  const IconComponent = tokenStatus === 'token_expired' || "token_used" ? WarningIcon : ErrorIcon;

  return (
    <PublicPage>
      <Box m={2}>
        <Container maxWidth="sm">
          <Card>
            <CardContent>
              {token.ok === null ? (
                <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <CircularProgress />
                </Box>
              ) : (
                <Stack gap={2}>
                  {token.ok ? (
                    <Box display="flex" alignItems="center" gap={2} width={"100%"}>
                      <Typography variant="body1" fontWeight={500} color='sucess' width={"100%"}>
                        {t('messages.register.confirm.ok')}
                      </Typography>
                      <CheckCircleIcon sx={{ fontSize: 32 }} color={"success"} />
                    </Box>
                  ) : (
                    <Box display="flex" alignItems="center" gap={2} width={"100%"}>
                      <Stack width={"100%"} gap={1}>
                        <Typography variant="body1" fontWeight={500} color="error">
                          {t('messages.register.confirm.fail')}
                        </Typography>
                        <Typography variant="body1" color="error">
                          {t(`messages.register.confirm.${tokenStatus}`)}
                        </Typography>
                      </Stack>
                      <IconComponent sx={{ fontSize: 32 }} color={iconColor} />
                    </Box>
                  )}
                  {tokenStatus === 'token_expired' ? (
                    <Button disabled={resentActivation} onClick={resendActivation} variant="contained" sx={{ width: 'max-content' }}>
                      {t('messages.register.confirm.token_resend')}
                    </Button>
                  ) : (
                    <Button onClick={() => navigate('/login')} variant="contained" sx={{ width: 'max-content' }}>
                      {t('buttons.login')}
                    </Button>
                  )}
                </Stack>
              )}
            </CardContent>
          </Card>
        </Container>
        <Loader open={isLoading} />
      </Box>
    </PublicPage>
  );
}

export default RegistrationConfirmPage;
